import React from "react";
import PropTypes from "prop-types";
import { MDBIcon } from "mdbreact";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from "react-share";

import "./styles.css";

const ShareBtns = ({ title }) => {
  const url = window.location.href;

  return (
    <div className="share">
      <ul>
        <li className="share-title">Compartilhe: </li>

        <WhatsappShareButton url={url}>
          <li className="share-whatsapp">
            <MDBIcon fab icon="whatsapp" />
          </li>
        </WhatsappShareButton>

        <FacebookShareButton url={url}>
          <li className="share-facebook">
            <MDBIcon fab icon="facebook-square" />
          </li>
        </FacebookShareButton>

        <TwitterShareButton url={url} title={title}>
          <li className="share-twitter">
            <MDBIcon fab icon="twitter" />
          </li>
        </TwitterShareButton>

        <LinkedinShareButton url={url}>
          <li className="share-linkedin">
            <MDBIcon fab icon="linkedin" />
          </li>
        </LinkedinShareButton>

        <EmailShareButton url={url} subject={title}>
          <li className="share-email">
            <MDBIcon far icon="envelope" />
          </li>
        </EmailShareButton>
      </ul>
    </div>
  );
};

ShareBtns.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ShareBtns;
